// @flow

const PREFIX = 'PST_';

const getKeyName = ({ key, prefix = PREFIX }) => `${prefix}${key}`;

type Storage = {
  getItem: (key: string) => string,
  setItem: (key: string, data: any) => mixed,
  removeItem: (key: string) => mixed
}

const getMessage = ({
  key,
  prefix = PREFIX,
  storage = window.sessionStorage,
}: {
  key: string,
  prefix?: string,
  storage?: Storage
}) => {
  const prefixedKey = getKeyName({ key, prefix });
  const m = storage.getItem(prefixedKey);

  if (m) {
    storage.removeItem(prefixedKey);
  }

  let v;

  try {
    v = JSON.parse(m);
  } catch (e) {
    v = m;
  }

  return v;
};

const setMessage = ({
  key,
  data,
  prefix = PREFIX,
  storage = window.sessionStorage,
}: {
  key: string,
  data: any,
  prefix?: string,
  storage?: Storage
}) => {
  const prefixedKey = getKeyName({ key, prefix });
  const oldValue = storage.getItem(prefixedKey);
  let newValue;

  if (oldValue) {
    let parsedOldValue;

    try {
      parsedOldValue = JSON.parse(oldValue);
    } catch (e) {
      parsedOldValue = oldValue;
    }

    if (Array.isArray(oldValue)) {
      newValue = [...parsedOldValue, data];
    } else if (typeof parsedOldValue === 'object') {
      newValue = {
        ...parsedOldValue,
        ...data,
      };
    } else {
      newValue = data;
    }
  }

  try {
    newValue = JSON.stringify(oldValue || data);
  } catch (e) {
    newValue = oldValue || data;
  }

  storage.setItem(prefixedKey, newValue);
};

export { getMessage, setMessage };
